import { createTheme, ThemeOptions } from "@material-ui/core/styles";

export const themeOptions: ThemeOptions = {
  typography: {
    fontFamily: "Montserrat",
    h1: {
      fontSize: "2rem",
      fontWeight: 500,
      letterSpacing: "-0.06px",
      lineHeight: 1.3,
    },
    h2: {
      fontSize: "1.68rem",
      letterSpacing: "-0.05px",
    },
    h3: {
      fontSize: "1.4rem",
      letterSpacing: "-0.05px",
    },
    h4: {
      fontSize: "1.2rem",
      letterSpacing: "-0.05px",
    },
    h5: {
      fontSize: "1rem",
      fontWeight: 500,

      lineHeight: "16px",
      letterSpacing: "-0.05px",
    },
    h6: {
      fontSize: "14px",
      lineHeight: "16px",
      letterSpacing: "-0.05px",
    },
    overline: {
      lineHeight: "13px",
    },
  },
  palette: {
    primary: {
      main: "#399ebf",
    },
    secondary: {
      main: "#1a224b",
    },
  },
  props: {
    MuiButtonBase: {
      disableRipple: true,
    },
    MuiButton: {
      disableElevation: true,
    },
    MuiPaper: {
      elevation: 0,
    },
  },
  overrides: {
    MuiAppBar: {
      root: {
        height: "64px",
        boxShadow: "10px 10px 99px 0 rgba(78, 80, 81, 0.07)",
      },
    },
    MuiButton: {
      root: {
        fontSize: "15px",
        letterSpacing: "0.035rem",
        padding: "0 18px",
        textTransform: "none",
        color: "inherit",
        fontWeight: "normal",
        lineHeight: 1,
        height: "38px",
      },
    },
    MuiTableRow: {
      root: {
        backgroundColor: "#fff",
        "&.MuiTableRow-root": {
          borderRadius: 15,
          backgroundColor: "#fff",
          borderBottom: "10px solid #f5f6f8",
          BorderTop: "10px solid #f5f6f8",
        },
        "&.MuiTableRow-hover": {
          borderRadius: 15,
          "&:hover": {
            backgroundColor: "#e3f8fa",
          },
        },
        "&.Mui-selected": {
          backgroundColor: "#e3f8fa",
        },
        "&:nth-of-type(odd)": {},
        cursor: "pointer",
        "& .MuiTableCell-root": {
          padding: 0,
        },
        "& .MuiTableCell-root:first-child": {
          paddingLeft: 20,
        },
        "& .MuiTableCell-root:last-child": {
          borderRadius: "0px 15px 15px 0px",
        },
      },
    },
    MuiTableCell: {
      head: {
        backgroundColor: "transparent",
        border: 0,
        color: "#399ebf",
        textTransform: "capitalize",
        position: "sticky",
        top: 0,
      },
      body: {
        border: 0,
        color: "#616161",
        fontSize: 14,
      },
      root: {
        height: "45px",
        "&:first-child": {
          padding: 0,
          paddingLeft: "10px",
        },
      },
    },
    MuiTable: {
      root: {
        "&.MuiTable-root": {
          borderCollapse: "separate",
        },
      },
    },

    MuiDialogTitle: {
      root: {
        borderBottom: "1px solid #d2cdcd",
        alignItems: "center",
        display: "flex",
        justifyContent: "space- between",
      },
    },
    MuiDialogActions: {
      root: {
        borderTop: "1px solid #d2cdcd",
        padding: "16px 24px",
        "& .MuiButtonBase-root": {
          height: "45px",
          textTransform: "uppercase",
        },
      },
    },
    MuiSnackbar: {
      root: {
        "& .MuiAlert-root": {
          borderRadius: "7px",
          padding: "0 16px",
          minWidth: "382px",
        },
        "& .MuiAlertTitle-root": {
          margin: "0",
          fontSize: "16px",
          textAlign: "left",
          fontWeight: "bold",
        },

        "& .MuiAlert-filledInfo": {
          color: "#399ebf",
          backgroundColor: "#d8ecf2",
          "& svg path": {
            fill: "#399ebf",
          },
        },
        "& .MuiAlert-filledWarning": {
          color: "#F2994A",
          backgroundColor: "#f6e5d5",
          "& svg path": {
            fill: "#F2994A",
          },
        },
        "& .MuiAlert-filledError": {
          color: "#E44E51",
          backgroundColor: "#f7cacb",
          "& svg path": {
            fill: "#E44E51",
          },
        },
        "& .MuiAlert-filledSuccess": {
          color: "#36AF47",
          backgroundColor: "#d7efda",
          "& svg path": {
            fill: "#36AF47",
          },
        },
        "& .MuiAlert-message": {
          fontWeight: "normal",
          textAlign: "left",
        },
        "& .MuiAlert-icon": {
          alignItems: "center",
        },
      },
    },
  },
};

export const theme = createTheme(themeOptions);
